import React from "react";
import { ArrowRight, ShieldCheck, Package, Clock } from "lucide-react";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export const Hero = () => {
  return (
    <section className="relative overflow-hidden px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto pt-10 sm:pt-16 pb-12 sm:pb-20">
      <div className="absolute -top-32 -right-32 w-[480px] h-[480px] rounded-full bg-[var(--oz-nude)] blur-[120px] opacity-60 pointer-events-none" />
      <div className="absolute top-40 -left-40 w-[420px] h-[420px] rounded-full bg-[var(--oz-rose)] blur-[130px] opacity-30 pointer-events-none" />

      <div className="relative grid lg:grid-cols-2 gap-10 lg:gap-14 items-center">
        <div className="oz-fade-up">
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-[var(--oz-gold)] mb-6">
            <span className="h-px w-8 bg-[var(--oz-gold)]" />
            Packs Pro Beauté
          </span>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-[3.4rem] leading-[1.05] font-medium tracking-tight text-[var(--oz-text)]">
            Et si votre passion pour la beauté devenait une source de revenus complémentaires ?
          </h1>
          <p className="mt-6 text-base sm:text-lg text-[var(--oz-muted)] leading-relaxed max-w-xl">
            Découvrez les Packs Pro Ozentya et choisissez la formule adaptée à votre projet.
            Des produits à découvrir, à présenter et à revendre auprès de votre clientèle et de
            votre entourage.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <button
              data-testid="hero-primary-cta"
              onClick={() => scrollTo("packs")}
              className="group inline-flex items-center justify-center gap-2 bg-[var(--oz-dark)] text-white px-8 py-4 rounded-full font-semibold text-sm tracking-wide hover:bg-black transition-all hover:gap-3"
            >
              DÉCOUVRIR LES PACKS
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" />
            </button>
            <button
              data-testid="hero-secondary-cta"
              onClick={() => scrollTo("how")}
              className="inline-flex items-center justify-center gap-2 border border-[var(--oz-text)]/25 px-8 py-4 rounded-full font-semibold text-sm tracking-wide hover:border-[var(--oz-gold)] hover:text-[var(--oz-gold)] transition-colors"
            >
              COMMENT ÇA MARCHE ?
            </button>
          </div>

          <div className="mt-8 flex flex-wrap gap-x-6 gap-y-3 text-sm text-[var(--oz-muted)]">
            <span className="inline-flex items-center gap-2"><Package className="w-4 h-4 text-[var(--oz-gold)]" /> 3 packs disponibles</span>
            <span className="inline-flex items-center gap-2"><ShieldCheck className="w-4 h-4 text-[var(--oz-gold)]" /> Paiement sécurisé</span>
            <span className="inline-flex items-center gap-2"><Clock className="w-4 h-4 text-[var(--oz-gold)]" /> À développer à votre rythme</span>
          </div>
        </div>

        <div className="relative oz-fade-up" style={{ animationDelay: "0.15s" }}>
          <div className="relative rounded-[2rem] overflow-hidden shadow-[0_40px_80px_-30px_rgba(26,23,20,0.45)]">
            <img
              src="https://static.prod-images.emergentagent.com/jobs/86773c59-3614-477d-9c71-250b0d9699a5/images/838b3ad280badb954f75402cddd99b1e12096986d21ef3c61b17feaac38581c8.jpeg"
              alt="Deux femmes élégantes présentant l'univers beauté Ozentya"
              className="w-full h-[380px] sm:h-[480px] lg:h-[560px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[var(--oz-dark)]/30 via-transparent to-transparent" />
          </div>
          <div className="absolute -bottom-5 -left-3 sm:left-6 bg-white rounded-2xl shadow-xl px-5 py-4 border border-[var(--oz-border)] flex items-center gap-4">
            <div className="text-center">
              <div className="font-serif text-2xl text-[var(--oz-text)]">10</div>
              <div className="text-[10px] uppercase tracking-wider text-[var(--oz-muted)]">produits</div>
            </div>
            <div className="h-8 w-px bg-[var(--oz-border)]" />
            <div className="text-center">
              <div className="font-serif text-2xl text-[var(--oz-text)]">15</div>
              <div className="text-[10px] uppercase tracking-wider text-[var(--oz-muted)]">produits</div>
            </div>
            <div className="h-8 w-px bg-[var(--oz-border)]" />
            <div className="text-center">
              <div className="font-serif text-2xl text-[var(--oz-gold)]">30</div>
              <div className="text-[10px] uppercase tracking-wider text-[var(--oz-muted)]">produits</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
